<template>
  <b-container>
    <b-row class="mt-4">
      <b-col>
        <Navigation
          targetPageValue="UserList"
          :targetPageName="$t('title.userManagement')"
          v-on:changePage="setNextPage"
        />
      </b-col>
    </b-row>
    <h1 class="text-center pt-4 pb-4">{{ $t("title.AddUser") }}</h1>
    <b-row>
      <b-col sm="6" class="mt-4">
        <v-select
          v-model="existingUser"
          :options="users"
          @search="searchUser"
          :placeholder="$t('action.chooseUser')"
          label="displayName"
        >
        </v-select>
      </b-col>
    </b-row>
    <hr />
    <div v-if="existingUser">
      <b-form @submit="onSubmit">
        <b-row>
          <b-col sm class="mt-4">
            <b-form-input
              v-model="existingUser.givenName"
              :placeholder="$t('label.fname')"
              readonly
            ></b-form-input>
          </b-col>
          <b-col sm class="mt-4">
            <b-form-input
              v-model="existingUser.surname"
              :placeholder="$t('label.fname')"
              readonly
            ></b-form-input>
          </b-col>
        </b-row>

        <b-row class="mt-2">
          <b-col sm class="mt-4">
            <b-form-input
              v-model="existingUser.mail"
              :placeholder="$t('label.email')"
              readonly
            ></b-form-input>
          </b-col>
          <b-col sm class="mt-4">
            <b-form-select v-model="form.role" :options="roles"></b-form-select>
            <div
              class="text-danger"
              v-if="!$v.form.role.required && $v.form.role.$dirty"
            >
              {{ $t("info.required") }}
            </div>
          </b-col>
        </b-row>

        <b-row v-if="buildings.length > 0 && (form.role === 1 || form.role === 5 || form.role === 6)" class="mt-2">
          <b-col sm=6 >
            <div class="mt-2">
              <b-alert show variant="info">
                <div>
                  <strong>{{ $t("info.buildingForUser") }}</strong>
                </div>

                <div class="mt-2" v-if="buildingList.length > 0">
                  <ul>
                    <li v-for="item in buildingList" :key="item.Id">
                      {{ item.NOMDIV }}
                    </li>
                  </ul>
                  <b-button
                    variant="link"
                    @click="resetMultiSelectList('buildingList')"
                    >{{ $t("action.resetTheList") }}</b-button
                  >
                </div>

                <div class="mt-4">
                  <b-button
                    variant="outline-info"
                    @click="openmodal('multiSelectTable')"
                    >{{ $t("action.addBuildingForUser") }}</b-button
                  >
                </div>
              </b-alert>
            </div>
          </b-col>
        </b-row>

        <b-modal
          id="multiSelectTable"
          size="xl"
          :title="$t('action.addBuildingForUser')"
          hide-footer
        >
          <MultiSelectTable
            ref="multiSelectBuilding"
            :tableDataFromProp="buildings"
            :fields="fieldsForMultipleSelectTable"
            tableName="buildingList"
          />
        </b-modal>

        <div>
          <b-button
            class="mt-4"
            type="submit"
            variant="success"
            :disabled="disabled"
            >{{ $t("action.submit") }}</b-button
          >
        </div>
      </b-form>
    </div>

    <div v-if="spinner" class="text-center align-middle">
      <b-spinner
        style="width: 3rem; height: 3rem"
        variant="success"
        label="Spinning"
        disabled="labelStatus"
      ></b-spinner>
    </div>

    <b-row v-if="success" class="text-center pt-4">
      <b-col>
        <b-alert show variant="success">
          <p>{{ $t("info.successgeneric") }}</p>
        </b-alert>
      </b-col>
    </b-row>

    <b-row v-if="error" class="mt-2">
      <b-col sm class="mt-4">
        <b-alert show variant="danger">
          <p>{{ error }}</p>
        </b-alert>
      </b-col>
    </b-row>
    <b-row v-if="emailexist" class="mt-2">
      <b-col sm class="mt-4">
        <b-alert show variant="warning">
          <p>{{ $t("info.emailexistuser") }}</p>
        </b-alert>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import axios from "axios";
import { required } from "vuelidate/lib/validators";
import { globalF } from "../../Helpers";
import MultiSelectTable from "../MultipleSelectTable.vue";
import Navigation from "../../Navigation.vue";

export default {
  mixins: [globalF],
  data() {
    return {
      form: {
        Id: null,
        fname: null,
        lname: null,
        email: null,
        role: null,
        env: "prod",
      },
      allDomains: [],
      buildings: [],
      existingUser: null,
      spinner: false,
      success: false,
      disabled: false,
      users: [],
      error: "",
      info: "",
      readonly: false,
      emailexist: false,
    };
  },
  validations() {
    return {
      form: {
        role: {
          required,
        },
      },
    };
  },
  mounted() {
    this.$store.commit("addBuildingListForUser", []);
    let token = this.getGlobalData("accessToken");
    this.getAllDomains(token);
    this.getBuildingList();
  },
  computed: {
    url: function () {
      return this.getUrl();
    },
    roles: function () {
      let roles = this.getGlobalData("roles");
      //let filterRoles = roles.filter(r => r.Id !== 4);
      let selectRoles = roles.map((r) => {
        return {
          text: r.en,
          value: r.Id,
        };
      });
      selectRoles.unshift({ value: null, text: "Role" });
      return selectRoles;
    },
    fieldsForMultipleSelectTable: function () {
      return [
        { key: "NOCIE", sortable: true, label: "NOCIE" },
        { key: "NODIV", sortable: true, label: "NODIV" },
        { key: "NOMDIV", sortable: true, label: "NOMDIV" },
        { key: "Creation", sortable: true, label: this.$t("label.date") },
        { key: "details", label: this.$t("label.detail") },
      ];
    },
    buildingList: function () {
      return this.$store.getters.getBuildingListForUser;
    },
  },
  methods: {
    searchUser: function (search) {
      //this.actionCall("allUsers", search);
      let token = this.getGlobalData("accessToken");
      this.getAllUsers(token, search);
    },
    getAllUsers(token, searchText) {
      if (searchText) {
        this.spinner = true;
        let graphEndpoint = `https://graph.microsoft.com/v1.0/users?$filter=startswith(displayName,'${searchText}')&$expand=manager($select=id,displayName,mail)&$count=true&$top=10`;
        axios
          .get(graphEndpoint, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
              ConsistencyLevel: "eventual",
            },
          })
          .then((response) => {
            this.spinner = false;
            if (response.status === 200) {
              this.users = response.data.value.filter(
                (a) =>
                  a.displayName.indexOf("*") === -1 &&
                  this.validateTenantDomain(a.mail, this.allDomains)
              );
            } else {
              this.error = this.$t("info.errorgeneric");
            }
          })
          .catch(() => {
            this.error = this.$t("info.errorgeneric");
            this.spinner = false;
          });
      }
    },
    getBuildingList() {
      this.spinner = true;
      let urls = this.$store.getters.getUrlsList;
      let url = urls[process.env.VUE_APP_WHERE].json;

      let promise = this.validateToken();
      promise.then(() => {
        axios
          .post(
            url,
            { request: "getAllBuilding" },
            { headers: { "Content-Type": "application/json" } }
          )
          .then((response) => {
            this.spinner = false;
            //this.$store.commit('setReloadValue', false);
            //this.$store.commit('addUserList', response.data.users);
            //this.$store.commit('addUsersBuilding', response.data.userBuilding);
            //this.allBuilding = response.data.buildings;
            this.buildings = response.data.buildings;
          })
          .catch(() => {
            this.spinner = false;
            this.error = this.$t("info.errorgeneric");
          });
      });
    },
    setNextPage(page) {
      this.$emit("changePage", page);
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.emailexist = false;
      this.error = "";
      this.$v.$touch();
      if (!this.$v.$invalid) {
        /*Ajax Call*/
        this.spinner = true;

        this.form.fname = this.existingUser.givenName;
        this.form.lname = this.existingUser.surname;
        this.form.email = this.existingUser.mail;
        this.form.buildingList = this.buildingList;

        this.addUser();
      }
    },
    resetField: function () {
      this.$v.$reset();
      this.form.fname = "";
      this.form.lname = "";
      this.form.role = null;
      this.existingUser = false;
    },
    openmodal: function (id) {
      this.$bvModal.show(id);
    },
    resetMultiSelectList: function (listName) {
      if (listName === "buildingList") {
        this.$store.commit("addBuildingListForUser", []);
      }
    },
    addUser: function () {
      let promise = this.validateToken();
      promise.then(() => {
        axios
          .post(
            this.url,
            { request: "addNewUser", form: this.form },
            { headers: { "Content-Type": "application/json" } }
          )
          .then((response) => {
            let res = response.data;
            this.spinner = false;

            if (res === "emailexist") {
              this.emailexist = true;
              this.disabled = false;
            } else {
              this.resetField();
              this.$emit("changePage", "UserList");
            }
          })
          .catch(() => {
            this.spinner = false;
            this.error = this.$t("info.errorgeneric");
            this.disabled = false;
          });
      });
    },
  },
  components: {
    MultiSelectTable,
    Navigation
  },
};
</script>